<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Formatos">
        <nz-page-header-extra class="flex">
            <nz-space>
                <!--------------------------- TODO: CAN CREATE FROM HERE?
                <button class="button primary-button" (click)="create()">
                    Añadir
                </button>
                ----------------------------->
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>

    <nz-table #packagingsTable nzTableLayout="auto" nzSize="small" [nzData]="packagings" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true">
        <thead>
            <tr>
                <th nzWidth="200px">Tipo de formato</th>
                <th nzWidth="200px">Lote</th>
                <th nzWidth="200px">Referencia externa</th>
                <th nzWidth="200px">Cantidad</th>
                <!--------------------------- TODO: CAN EDIT AND DELETE FROM HERE?
                <th nzWidth="200px">Acciones</th>
                -->
            </tr>
        </thead>
        <tbody>
            @for (data of packagingsTable.data; track data.id) {
            <tr>
                <td>{{ data.packagingType?.name }}</td>
                <td>{{ data.batchNumber }}</td>
                <td>{{ data.externalBatchNumber ? data.externalBatchNumber : '-'}}</td>
                <td>{{ data.quantity }} {{ data.packagingType?.measurementUnit?.abbreviation }}</td>
                <!--------------------------- TODO: CAN EDIT AND DELETE FROM HERE?
                <td>
                    <div class="flex align-middle justify-center">
                        <--------------------------- TODO: PERMISSIONS -----------------------------
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Ver formato'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="view(data)">
                            <span nz-icon nzType="eye"></span>
                        </button>
                        
                        <nz-divider nzType="vertical"></nz-divider>
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Editar formato'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="edit(data)">
                            <span nz-icon nzType="edit"></span>
                        </button>
                        <nz-divider nzType="vertical"></nz-divider>
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Eliminar formato'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="delete(data.id!)">
                            <span nz-icon nzType="delete"></span>
                        </button>
                    </div>
                </td>----------------------------->
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'500px'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label>
                        Referencia externa
                    </nz-form-label>
                    <nz-form-control>
                        <input onfocus="select()" nz-input placeholder="Indique una referencia externa para el formato"
                            type="text" id="externalBatchNumber" formControlName="externalBatchNumber" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Cantidad
                    </nz-form-label>
                    <nz-form-control nzErrorTip="La cantidad del formato debe de ser mayor que 0">
                        <input onfocus="select()" nz-input placeholder="Indique un nombre para el formato" type="number"
                            pattern="\d*" id="quantity" formControlName="quantity" />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>

    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
            <button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()">
                Guardar
            </button>
            }
        </div>
    </ng-template>
</nz-drawer>